/**
 * @generated SignedSource<<831a47f787266895aeb286c40fa5e0ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type PlanModalMutation$variables = {
  id: string;
  state: InspectionfieldStateEnum;
  timestamp: number;
};
export type PlanModalMutation$data = {
  readonly modifyInspectionfieldDate: {
    readonly inspectionfield: {
      readonly plannedDate: any | null;
      readonly state: InspectionfieldStateEnum | null;
    } | null;
  } | null;
};
export type PlanModalMutation = {
  response: PlanModalMutation$data;
  variables: PlanModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "state"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timestamp"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      },
      {
        "kind": "Variable",
        "name": "timestamp",
        "variableName": "timestamp"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlanModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyInspectionfieldDatePayload",
        "kind": "LinkedField",
        "name": "modifyInspectionfieldDate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNode",
            "kind": "LinkedField",
            "name": "inspectionfield",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlanModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyInspectionfieldDatePayload",
        "kind": "LinkedField",
        "name": "modifyInspectionfieldDate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNode",
            "kind": "LinkedField",
            "name": "inspectionfield",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "29f7d3deb5309d4c097ea9795c2e9070",
    "id": null,
    "metadata": {},
    "name": "PlanModalMutation",
    "operationKind": "mutation",
    "text": "mutation PlanModalMutation(\n  $id: ID!\n  $state: InspectionfieldStateEnum!\n  $timestamp: Float!\n) {\n  modifyInspectionfieldDate(input: {id: $id, timestamp: $timestamp, state: $state}) {\n    inspectionfield {\n      state\n      plannedDate\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bbe0624ac7631df737b8b9f6e939e2a";

export default node;
